module.exports = __webpack_public_path__ + "static/media/LeopardDistribution.8963b932.jpg";